import React from 'react';
import { Form } from 'react-bootstrap';

const InputControl = ({
    autoFocus=false,
    className,
    login,
    error,
    label,
    name,
    register,
    textarea,
    type = 'text',
    ...rest
}) => {
    return (
        <Form.Group
            className={
                !className
                    ? 'mb-3 input-wrapper'
                    : `mb-3 input-wrapper ${className}`
            }
        >
            <Form.Label className="label-name lcontrol">{label}</Form.Label>
            <Form.Control
                autoFocus={autoFocus}
                className={textarea ? 'tcontrol' : 'icontrol input-text'}
                style={{padding: '0px 15px'}}
                type={type}
                {...(register && register(name))}
                {...rest}
            />
            {error && (
                <span className="error-message" style={{ color: 'red' }}>
                    {error}
                </span>
            )}
        </Form.Group>
    );
};

export default InputControl;
